/* Oinks link (header): opens the customer portal on its Oinks tab.
   The portal's address is per customer, so the link goes through /tools/recurring/login (signing in
   first if needed) and leaves a note in sessionStorage; bb-portal.js sees it and switches to Oinks.
   If storage is blocked the link still opens the portal. */
(function () {
  document.querySelectorAll('[data-bb-oinks]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      try { sessionStorage.setItem('bb_portal_open', 'credits'); } catch (err) {}
      if (a.getAttribute('data-signed-in') === 'true') return;
      e.preventDefault();
      var login = a.getAttribute('data-login-url');
      location.href = login + (login.indexOf('?') < 0 ? '?' : '&') + 'return_to=' + encodeURIComponent(a.getAttribute('href'));
    });
  });
})();
